export function getPhoneDigits(value: string | null | undefined): string {
  return value?.replace(/\D/g, '') ?? ''
}

export function isValidPhoneInput(value: string | null | undefined): boolean {
  const digits = getPhoneDigits(value)
  return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'))
}

export function formatPhoneDisplay(value: string | null | undefined): string {
  const normalized = value?.trim()
  if (!normalized) return ''

  const digits = getPhoneDigits(normalized)

  if (digits.length === 10) {
    const areaCode = digits.slice(0, 3)
    const prefix = digits.slice(3, 6)
    const lineNumber = digits.slice(6)
    return `(${areaCode}) ${prefix}-${lineNumber}`
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    const areaCode = digits.slice(1, 4)
    const prefix = digits.slice(4, 7)
    const lineNumber = digits.slice(7)
    return `+1 (${areaCode}) ${prefix}-${lineNumber}`
  }

  return normalized
}

export function formatPhoneInput(value: string | null | undefined): string {
  const normalized = value?.trim() ?? ''
  const digits = getPhoneDigits(normalized)

  if (!digits) return ''

  const hasCountryCode = digits.length > 10 && digits.startsWith('1')
  const nationalDigits = hasCountryCode ? digits.slice(1, 11) : digits.slice(0, 10)

  if (hasCountryCode) {
    if (nationalDigits.length <= 3) return `+1 (${nationalDigits}`
    if (nationalDigits.length <= 6) {
      return `+1 (${nationalDigits.slice(0, 3)}) ${nationalDigits.slice(3)}`
    }
    return `+1 (${nationalDigits.slice(0, 3)}) ${nationalDigits.slice(3, 6)}-${nationalDigits.slice(6)}`
  }

  if (digits.length <= 3) return digits.length === 3 ? `(${digits})` : digits
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`
}
